import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react';
import clsx from 'clsx';
import styles from './PageTitle.style';

const PageTitle = ({ children, className: classNameProp, fullWidth, ...other }) => {
  const className = clsx(styles.root, classNameProp, fullWidth && styles.fullWidth);

  return (
    <Text as="h1" className={className} {...other}>
      {children}
    </Text>
  );
};

PageTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};

PageTitle.defaultProps = {
  children: '',
  className: '',
  fullWidth: false,
};

export default PageTitle;
